import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TickCircleIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  width: "1rem",
  height: "1rem",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5m5.56-12.44a1.5 1.5 0 0 0-2.12-2.12l-4.94 4.939-1.94-1.94a1.5 1.5 0 0 0-2.12 2.122l3 3a1.5 1.5 0 0 0 2.12 0z"
  })
});
export default TickCircleIcon;